import src from "IMAGE";
export default { src, width: 960, height: 161, blurWidth: 0, blurHeight: 0};
